<app-banner></app-banner>
<app-statistics></app-statistics>
<app-static-text></app-static-text>
<app-features></app-features>
<app-faq></app-faq>
<app-partners></app-partners>
<app-footer></app-footer>

